/* Französischer Sprachkatalog. Schlüssel ist der deutsche Quelltext. */

const texte = {
  "Rot": "Rouge",
  "Weiß": "Blanc",
  "Rosé": "Rosé",
  "Schaumwein": "Effervescent",
  "Edelsüß": "Liquoreux",
  "Orange": "Orange",
  "Gespritet": "Muté",
  "100-Punkte-Skala": "Échelle sur 100 points",
  "20-Punkte-Skala": "Échelle sur 20 points",
  "5-Sterne-Skala": "Échelle 5 étoiles",
  "Prozent-Skala": "Échelle en pourcentage",
  "0,375 l · Halbe Flasche": "0,375 l · Demi-bouteille",
  "0,5 l · Süßweinflasche": "0,5 l · Vin liquoreux",
  "0,75 l · Standard": "0,75 l · Standard",
  "1,5 l · Magnum": "1,5 l · Magnum",
  "3 l · Doppelmagnum": "3 l · Double magnum",
  "6 l · Imperial": "6 l · Impériale",
  "Name A–Z": "Nom A–Z",
  "Name Z–A": "Nom Z–A",
  "Jahrgang jung–alt": "Millésime, du plus récent",
  "Jahrgang alt–jung": "Millésime, du plus ancien",
  "Jahrgang, neueste zuerst": "Millésime, du plus récent",
  "Jahrgang, älteste zuerst": "Millésime, du plus ancien",
  "Preis hoch–niedrig": "Prix, décroissant",
  "Preis niedrig–hoch": "Prix, croissant",
  "Preis aufsteigend": "Prix, croissant",
  "Preis absteigend": "Prix, décroissant",
  "Bewertung hoch–niedrig": "Note, décroissante",
  "Bewertung niedrig–hoch": "Note, croissante",
  "Bestand, meiste zuerst": "Stock, du plus grand",
  "Jede Trinkreife": "Toute maturité",
  "Noch nicht trinkreif": "Pas encore prêt",
  "Trinkreif": "Prêt à boire",
  "Überfällig": "Au-delà de son apogée",
  "Weinkarte": "Carte des vins",
  "Weinkeller": "Cave à vin",
  "Keller": "Cave",
  "Weine": "Vins",
  "Winzer": "Vignerons",
  "Regionen": "Régions",
  "Karte": "Carte",
  "Filter": "Filtres",
  "Sortierung": "Tri",
  "Zurücksetzen": "Réinitialiser",
  "Zurück": "Retour",
  "Nur ansehen": "Lecture seule",
  "Wird geladen …": "Chargement …",
  "Alle Typen": "Tous les types",
  "Alle Jahrgänge": "Tous les millésimes",
  "Alle Länder": "Tous les pays",
  "Alle Regionen": "Toutes les régions",
  "Alle Winzer": "Tous les vignerons",
  "Alle Rebsorten": "Tous les cépages",
  "Alle Labels": "Tous les labels",
  "andere Suche": "autre recherche",
  "Für diesen Winzer sind noch keine Weine im Katalog.": "Aucun vin de ce vigneron dans le catalogue pour l'instant.",
  "Ein Wein dieses Winzers im Katalog:": "Un vin de ce vigneron dans le catalogue :",
  "{n} Weine dieses Winzers im Katalog:": "{n} vins de ce vigneron dans le catalogue :",
  "Eigenen Wein dieses Winzers anlegen": "Créer son propre vin de ce vigneron",
  "Aus dem Katalog": "Depuis le catalogue",
  "Eigener Jahrgang": "Millésime personnel",
  "Kritiken": "Critiques",
  "Witterung": "Météo",
  "Ohne Winzer": "Sans vigneron",
  "Ohne Region": "Sans région",
  "Ohne Land": "Sans pays",
  "Diese Weinkarte ist noch leer.": "Cette carte des vins est encore vide.",
  "Geteilt über WineLake · schreibgeschützte Ansicht": "Partagé via WineLake · lecture seule",
  "Keine Flaschen im Bestand.": "Aucune bouteille en stock.",
  "Keine Positionen gefunden.": "Aucune entrée trouvée.",
  "Keine Regionen gefunden.": "Aucune région trouvée.",
  "Keine Weine gefunden.": "Aucun vin trouvé.",
  "Keine Winzer gefunden.": "Aucun vigneron trouvé.",
  "Weine auf dieser Karte": "Vins de cette carte",
  "Der Server ist nicht erreichbar.": "Le serveur est injoignable.",
  "Diese Freigabe ist nicht verfügbar.": "Ce partage n’est pas disponible.",
  "Etikett vergrößern": "Agrandir l’étiquette",
  "Etikett": "Étiquette",
  "Mittel": "Moyenne",
  "Wärmesumme": "Somme de températures",
  "Niederschlag": "Précipitations",
  "Sonne": "Ensoleillement",
  "Hitzetage": "Jours de chaleur",
  "Frosttage": "Jours de gel",
  "Verkostung": "Dégustation",
  "Wein": "Vin",
  "Vegetationsperiode {zeitraum}": "Période végétative {zeitraum}",
  "Trinkfenster {von}–{bis}": "Fenêtre de dégustation {von}–{bis}",
  "Zurück zu Winzern": "Retour aux vignerons",
  "Zurück zu Regionen": "Retour aux régions",
  "{n} Fl.": "{n} bt.",
  "ein Wein": "1 vin",
  "{n} Weine": "{n} vins",
  "Rückmeldung": "Retour",
  "Fehler gefunden, etwas vermisst oder eine Idee? Schreib mir gern — jede Rückmeldung hilft.": "Un bug, un manque ou une idée ? Écrivez-moi, chaque retour est utile.",
  "Einführung": "Introduction",
  "Ein Überblick über die wichtigsten Funktionen. Die Abschnitte lassen sich einzeln aufklappen.": "Un aperçu des principales fonctions. Chaque section s'ouvre séparément.",
  "{n} Wein": "{n} vin",
  "{n} Position": "{n} ligne",
  "{n} Positionen": "{n} lignes",
  "Sprache der Karte": "Langue de la carte",
  "Automatisch (Sprache des Gastes)": "Automatique (langue du visiteur)",
  "Aktualisieren": "Actualiser",
  "Statistik": "Statistiques",
  "Nur mit Bestand": "Uniquement en stock",
  "Mein Konto": "Mon compte",
  "Teilen": "Partage",
  "Katalog": "Catalogue",
  "Daten": "Données",
  "Verwaltung": "Administration",
  "Menü": "Menu",
  "Datenstand": "État des données",
  "Datenhaltung": "Stockage",
  "Abmelden": "Se déconnecter",
  "Keller löschen": "Supprimer la cave",
  "E-Mail & Passwort": "E-mail et mot de passe",
  "Keller teilen": "Partager la cave",
  "Weinkarten": "Cartes des vins",
  "Änderungen": "Modifications",
  "Meine Vorschläge": "Mes propositions",
  "Vorschläge prüfen": "Examiner les propositions",
  "Zusammenführen": "Fusionner les doublons",
  "Wetterdaten laden": "Charger la météo",
  "Excel exportieren": "Exporter vers Excel",
  "Excel importieren": "Importer depuis Excel",
  "Leere Vorlage": "Modèle vierge",
  "Cloud": "Cloud",
  "Lokal": "Local",
  "Admin": "Admin",
  "Wird gespeichert …": "Enregistrement …",
  "Prüfe …": "Vérification …",
  "Offline — lokal gesichert": "Hors ligne — enregistré localement",
  "Synchronisiert · Stand {v}": "Synchronisé · version {v}",
  "Stammdaten aus dem gemeinsamen Katalog übernehmen.": "Reprendre les données du catalogue partagé.",
  "Nur deine eigenen Daten, kein Katalog.": "Uniquement vos données, sans catalogue.",
  "Die Katalog-Synchronisation wurde für dieses Konto abgeschaltet. Deine eigenen Daten bleiben nutzbar.": "La synchronisation du catalogue est désactivée pour ce compte. Vos données restent utilisables.",
  "Sprache": "Langue",
  "Jahrgang": "Millésime",
  "Typ": "Type",
  "Region": "Région",
  "Land": "Pays",
  "Bestand": "Stock",
  "Flaschen": "Bouteilles",
  "Positionen": "Entrées",
  "Preis": "Prix",
  "Lager": "Rangement",
  "Kritik": "Note",
  "Kellerwert": "Valeur de la cave",
  "Wein anlegen": "Ajouter un vin",
  "Keller durchsuchen …": "Rechercher dans la cave …",
  "Lieblingswein": "Coup de cœur",
  "Keine Positionen gefunden. Lege einen Wein an oder passe Suche und Filter an.": "Aucune entrée trouvée. Ajoutez un vin ou ajustez la recherche et les filtres.",
  "Alle Weine": "Tous les vins",
  "Nur Lieblingsweine": "Coups de cœur uniquement",
  "Alle Lagerorte": "Tous les rangements",
  "Filter zurücksetzen": "Réinitialiser les filtres",
  "Bestand hoch–niedrig": "Stock, décroissant",
  "Bestand niedrig–hoch": "Stock, croissant",
  "Trinkreife alt–jung": "Maturité, du plus ancien",
  "Trinkreife jung–alt": "Maturité, du plus récent",
  "Bearbeiten": "Modifier",
  "Öffnen": "Ouvrir",
  "Zur Weinliste": "Vers la liste des vins",
  "Zum Wein": "Vers le vin",
  "Zur Winzerliste": "Vers la liste des vignerons",
  "Zu den Regionen": "Vers les régions",
  "Zurück zu den Ländern": "Retour aux pays",
  "Im Keller zeigen": "Voir dans la cave",
  "Jahrgänge": "Millésimes",
  "Winzer anlegen": "Ajouter un vigneron",
  "Region anlegen": "Ajouter une région",
  "Jahrgang anlegen": "Ajouter un millésime",
  "Kritik erfassen": "Ajouter une note",
  "Wein löschen": "Supprimer le vin",
  "Winzer löschen": "Supprimer le vigneron",
  "Region löschen": "Supprimer la région",
  "Jahrgang löschen": "Supprimer le millésime",
  "Entfernen": "Retirer",
  "Vergrößern": "Agrandir",
  "Bewertung": "Note",
  "Kritiker / Quelle": "Critique / source",
  "Anlass / Pairing": "Occasion / accord",
  "Notiz": "Note",
  "Trinkfenster": "Fenêtre de dégustation",
  "Ein- & Auslagerungen": "Mouvements de stock",
  "Eingelagert": "Entré",
  "Entnommen": "Sorti",
  "Auf Weinkarte": "Sur la carte",

  /* Trinkverlauf */
  "Trinkverlauf": "Journal de cave",
  "Einlagerungen": "Entrées",
  "Entnahmen": "Sorties",
  "Art der Bewegung": "Type de mouvement",
  "Alle Jahre": "Toutes les années",
  "Jahr": "Année",
  "Suchen": "Rechercher",
  "Wein, Winzer, Händler …": "Vin, vigneron, caviste …",
  "eingelagert": "entré",
  "ausgelagert": "sorti",
  "Saldo": "Solde",
  "Jg.": "Mill.",
  "Ohne Datum": "Sans date",
  "Unbekannter Wein": "Vin inconnu",
  "Zu dieser Auswahl gibt es keine Bewegungen.": "Aucun mouvement pour cette sélection.",
  "Noch keine Ein- oder Auslagerungen erfasst. Sobald du Flaschen einlagerst oder entnimmst, entsteht hier der Verlauf.": "Aucun mouvement enregistré pour l'instant. Dès que vous entrez ou sortez des bouteilles, le journal apparaîtra ici.",
  "Alk.": "Alc.",
  "Säure": "Acidité",
  "Ausbau": "Élevage",
  "Geschmack": "Goût",
  "Boden": "Sol",
  "Dieser Wein existiert nicht mehr.": "Ce vin n’existe plus.",
  "Kein Jahrgang dieses Weins hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Aucun millésime de ce vin n’est en stock. Désactivez « Uniquement en stock » pour tout voir.",
  "Noch kein Jahrgang erfasst. Lege den ersten Jahrgang mit Analysewerten und Anfangsbestand an.": "Aucun millésime enregistré. Ajoutez le premier avec les valeurs analytiques et le stock initial.",
  "Noch keine Kritiken erfasst.": "Aucune critique.",
  "Analyse & Kellerdaten": "Analyse et données de cave",
  "Alkohol": "Alcool",
  "Restzucker": "Sucre résiduel",
  "Schwefel": "Soufre",
  "Zuckerkategorie": "Catégorie de sucre",
  "Reife": "Maturité",
  "Verschluss": "Bouchage",
  "Kapsel": "Capsule",
  "Lagerort": "Emplacement",
  "Preis (Flasche)": "Prix (bouteille)",
  "Ø Einstand": "Ø prix d’achat",
  "Flaschen im Bestand": "Bouteilles en stock",
  "Bezugsquellen": "Sources d’achat",
  "Zugang": "Entrée",
  "Entnehmen": "Sortir",
  "Neu aufnehmen": "Nouvel ajout",
  "Etikettenfoto hinzufügen": "Ajouter une photo d’étiquette",
  "Bild wählen": "Choisir une image",
  "Wird hochgeladen …": "Téléversement …",
  "Dieser Jahrgang existiert nicht mehr.": "Ce millésime n’existe plus.",
  "Für diesen Jahrgang ist noch keine Kritik erfasst.": "Aucune note pour ce millésime.",
  "Für Weine ohne Jahrgang (N.V.) gibt es keine jahresbezogene Witterung.": "Les vins sans millésime (N.V.) n’ont pas de météo annuelle.",
  "Ort": "Commune",
  "Rebsorten": "Cépages",
  "Winzer durchsuchen …": "Rechercher des vignerons …",
  "Nach Land filtern": "Filtrer par pays",
  "Nach Region filtern": "Filtrer par région",
  "Nach Rebsorte filtern": "Filtrer par cépage",
  "Nach Label filtern": "Filtrer par label",
  "Dieser Winzer existiert nicht mehr.": "Ce vigneron n’existe plus.",
  "Für diesen Winzer ist noch kein Wein erfasst.": "Aucun vin enregistré pour ce vigneron.",
  "Kein Wein dieses Winzers hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Aucun vin de ce vigneron n’est en stock. Désactivez « Uniquement en stock » pour tout voir.",
  "Keine Winzer gefunden. Lege einen Winzer an oder passe Suche und Filter an.": "Aucun vigneron trouvé. Ajoutez-en un ou ajustez la recherche et les filtres.",
  "Zuerst die Weine dieses Winzers löschen oder umziehen.": "Supprimez ou déplacez d’abord les vins de ce vigneron.",
  "Alle": "Tous",
  "Appellation": "Appellation",
  "Appellationen": "Appellations",
  "Koordinaten": "Coordonnées",
  "Weine dieser Region": "Vins de cette région",
  "Weinen": "vins",
  "Länder & Regionen durchsuchen …": "Rechercher pays et régions …",
  "Diese Region existiert nicht mehr.": "Cette région n’existe plus.",
  "Aus dieser Region ist noch kein Wein erfasst.": "Aucun vin enregistré pour cette région.",
  "Noch keine Beschreibung hinterlegt.": "Aucune description.",
  "Noch keine Winzer in dieser Region.": "Aucun vigneron dans cette région.",
  "Kein Land gefunden. Passe Suche und Filter an oder lege eine Region an.": "Aucun pays trouvé. Ajustez la recherche ou ajoutez une région.",
  "Keine Region gefunden — Suche und Filter anpassen oder eine Region anlegen.": "Aucune région trouvée — ajustez la recherche ou ajoutez-en une.",
  "Keine Region gefunden. Passe die Suche an oder lege eine Region an.": "Aucune région trouvée. Ajustez la recherche ou ajoutez-en une.",
  "Kein Wein dieser Region hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Aucun vin de cette région n’est en stock. Désactivez « Uniquement en stock » pour tout voir.",
  "Zuerst die Winzer dieser Region löschen oder umziehen.": "Supprimez ou déplacez d’abord les vignerons de cette région.",
  "Abbrechen": "Annuler",
  "Schließen": "Fermer",
  "Löschen": "Supprimer",
  "Anlegen": "Créer",
  "Speichern": "Enregistrer",
  "Auswählen …": "Sélectionner …",
  "Wählen …": "Choisir …",
  "Name": "Nom",
  "Datum": "Date",
  "Menge": "Quantité",
  "Größe": "Format",
  "Fl.": "bt.",
  "Quelle": "Source",
  "Ziel": "Cible",
  "Stand": "Version",
  "Zuletzt": "Dernière activité",
  "Offen": "Ouverte",
  "Gesperrt": "Fermée",
  "Wetter": "Météo",
  "Benutzername": "Nom d’utilisateur",
  "Registriert": "Inscrit",
  "Registrierung": "Inscription",
  "E-Mail": "E-mail",
  "Passwort ändern": "Changer le mot de passe",
  "Bisheriges Passwort": "Mot de passe actuel",
  "Neues Passwort": "Nouveau mot de passe",
  "Neues Passwort wiederholen": "Confirmer le nouveau mot de passe",
  "Neues Passwort setzen": "Définir un nouveau mot de passe",
  "E-Mail oder Benutzername": "E-mail ou nom d’utilisateur",
  "Zur Anmeldung": "Vers la connexion",
  "Jetzt anmelden": "Se connecter",
  "Link wird geprüft …": "Vérification du lien …",
  "Konto löschen": "Supprimer le compte",
  "Weintyp": "Type de vin",
  "Alkohol (% vol)": "Alcool (% vol)",
  "Säure (g/l)": "Acidité (g/l)",
  "Restzucker (g/l)": "Sucre résiduel (g/l)",
  "Trinkfenster von": "Fenêtre à partir de",
  "Trinkfenster bis": "Fenêtre jusqu’à",
  "Flaschengröße": "Format de bouteille",
  "Anfangsbestand (0,75-l-Flaschen)": "Stock initial (bouteilles de 0,75 l)",
  "Kaufpreis je Flasche (€)": "Prix d’achat par bouteille (€)",
  "Kaufdatum": "Date d’achat",
  "Bezugsquelle": "Fournisseur",
  "Zugang buchen": "Enregistrer l’entrée",
  "Verkostungsnotiz": "Note de dégustation",
  "Bewertungsschema": "Échelle de notation",
  "Anlass": "Occasion",
  "Speisenbegleitung (Pairing)": "Accord mets-vins",
  "Kritik speichern": "Enregistrer la note",
  "Der Zugang wird dem Bestand der gewählten Flaschengröße gutgeschrieben. Bezugsquelle und Kaufpreis fließen in die Kaufhistorie ein.": "L’entrée est créditée au stock du format choisi. Le fournisseur et le prix alimentent l’historique d’achat.",
  "Nach der Entnahme kannst du direkt eine Verkostungsnotiz zum Jahrgang erfassen.": "Après une sortie, vous pouvez saisir directement une note de dégustation.",
  "Für diesen Jahrgang ist kein Bestand vorhanden — buche zuerst einen Zugang.": "Aucun stock pour ce millésime — enregistrez d’abord une entrée.",
  "Für diesen Wein existiert noch kein Jahrgang. Lege zuerst einen Jahrgang an, um Kritiken zu erfassen.": "Ce vin n’a pas encore de millésime. Ajoutez-en un pour saisir des notes.",
  "Neue Region": "Nouvelle région",
  "Neuer Winzer": "Nouveau vigneron",
  "Region suchen …": "Rechercher une région …",
  "Winzer suchen …": "Rechercher un vigneron …",
  "Kurzbeschreibung": "Description brève",
  "Klassifikation": "Classification",
  "Wichtige Rebsorten": "Cépages principaux",
  "Anteil in Prozent": "Part en pourcentage",
  "Rebsorte entfernen": "Retirer le cépage",
  "Breitengrad": "Latitude",
  "Längengrad": "Longitude",
  "Titel der Weinkarte": "Titre de la carte",
  "Titel der neuen Weinkarte": "Titre de la nouvelle carte",
  "Sichtbare Angaben": "Informations visibles",
  "Diese Weinkarte teilen": "Partager cette carte",
  "Widerrufen": "Révoquer",
  "Preis (€)": "Prix (€)",
  "Preis (€ / Flasche)": "Prix (€ / bouteille)",
  "Wein aus dem Keller wählen …": "Choisir un vin de la cave …",
  "Zurück in den Keller": "Remettre en cave",
  "Eine Flasche als ausgeschenkt buchen": "Enregistrer une bouteille servie",
  "Noch keine Flaschen auf dieser Karte.": "Aucune bouteille sur cette carte.",
  "Noch keine Weinkarten.": "Aucune carte des vins.",
  "Noch kein Freigabe-Link vorhanden.": "Aucun lien de partage.",
  "Im Keller liegen keine Flaschen, die sich auf eine Weinkarte setzen ließen.": "Aucune bouteille en cave à mettre sur une carte.",
  "Als PDF speichern / drucken": "Enregistrer en PDF / imprimer",
  "Annehmen": "Accepter",
  "Ablehnen": "Refuser",
  "Entschieden": "Décidées",
  "Zuletzt entschieden": "Décidées récemment",
  "Keine offenen Vorschläge.": "Aucune proposition ouverte.",
  "Nichts offen.": "Rien en attente.",
  "Katalogfassung übernehmen": "Adopter la version du catalogue",
  "Noch keine Änderungen, die dich betreffen.": "Aucune modification vous concernant.",
  "Bleibt bei dir erhalten und wird ab jetzt rein lokal geführt.": "Conservé chez vous et désormais géré uniquement en local.",
  "Dieses Objekt wird bei dir lokal geführt und nicht mehr abgeglichen.": "Cet élément reste local et n’est plus synchronisé.",
  "Nur Jahrgänge oder Rebsorten betroffen.": "Seuls les millésimes ou cépages sont concernés.",
  "Begründung (nur bei Ablehnung sinnvoll)": "Motif (utile en cas de refus)",
  "Mögliche Dubletten": "Doublons possibles",
  "Vorschau": "Aperçu",
  "Richtung tauschen": "Inverser le sens",
  "Jetzt zusammenführen": "Fusionner maintenant",
  "Im Katalog zusammenführen": "Fusionner dans le catalogue",
  "Quelle — geht auf und verschwindet": "Source — fusionnée puis supprimée",
  "Quelle — verschwindet": "Source — sera supprimée",
  "Ziel — bleibt bestehen": "Cible — conservée",
  "Ziel — bleibt": "Cible — conservée",
  "Quelle und Ziel müssen verschieden sein.": "La source et la cible doivent différer.",
  "Hier gibt es noch nichts zusammenzuführen.": "Rien à fusionner pour le moment.",
  "Dieser Schritt kann nicht rückgängig gemacht werden.": "Cette étape est irréversible.",
  "Bereich": "Domaine",
  "Neu angelegt": "Créés",
  "Aktualisiert / verknüpft": "Mis à jour / liés",
  "Übersprungen": "Ignorés",
  "Hinweise": "Remarques",
  "Betroffen": "Concernés",
  "Keine Konten vorhanden.": "Aucun compte.",
  "Registrierung öffnen oder sperren": "Ouvrir ou fermer l’inscription",
  "Teilen & Weinkarten": "Partage et cartes",
  "Wetterdaten für dieses Konto freischalten": "Activer la météo pour ce compte",
  "Keller teilen und Weinkarten für dieses Konto freischalten": "Activer le partage et les cartes pour ce compte",
  "Nimmt dieses Konto am gemeinsamen Katalog teil? Abschalten stoppt Zulieferungen und Aktualisierungen.": "Ce compte participe-t-il au catalogue partagé ? La désactivation arrête contributions et mises à jour.",
  "Alle aktualisieren": "Tout actualiser",
  "{n} Klimareihen vom Server": "{n} séries climatiques depuis le serveur",
  "bis zu {n} Jahrgänge vom Server": "jusqu’à {n} millésimes depuis le serveur",
  "{n} Jahrgänge aus der Klimareihe, ohne Abruf": "{n} millésimes tirés de la série climatique, sans requête",
  "Die Wetterdaten werden geladen. Bitte das Fenster geöffnet lassen. Was schon geholt ist, liegt auch auf dem Server bereit.": "Les données météo sont en cours de chargement. Gardez la fenêtre ouverte. Ce qui a déjà été récupéré reste aussi disponible sur le serveur.",
  "Minutengrenze bei Open-Meteo erreicht — es geht in {n} s weiter.": "Limite par minute d’Open-Meteo atteinte — reprise dans {n} s.",
  "Abgebrochen — das Kontingent bei Open-Meteo ist für den Moment erschöpft.": "Interrompu — le quota d’Open-Meteo est épuisé pour le moment.",
  "Noch offen: {n}. Was schon geholt ist, bleibt erhalten — später erneut „Nur fehlende auffüllen“ wählen.": "Encore en attente : {n}. Ce qui a déjà été récupéré est conservé — choisissez plus tard à nouveau « Compléter uniquement les manquants ».",
  "Nichts zu tun": "Rien à faire",
  "Ohne Vegetationsdaten sind Jahrgänge, deren Saison noch nicht begonnen hat — das ist normal.": "Les millésimes sans données de saison sont ceux dont la saison n’a pas encore commencé — c’est normal.",
  "Letzter Fehler: {text}": "Dernière erreur : {text}",
  "Fertig. Fehlende Daten wurden aufgefüllt.": "Terminé. Les données manquantes ont été complétées.",
  "Fertig. Alle Daten wurden aktualisiert.": "Terminé. Toutes les données ont été actualisées.",
  "Klimareihen geladen": "Séries climatiques chargées",
  "Jahrgänge vom Server": "Millésimes depuis le serveur",
  "Jahrgänge aus der Klimareihe": "Millésimes tirés de la série climatique",
  "Ohne Vegetationsdaten": "Sans données de saison",
  "Fehler": "Erreurs",
  "Klimareihen und Witterung für {r} Regionen und {j} Jahrgänge im Bestand.": "Séries climatiques et météo pour {r} régions et {j} millésimes en stock.",
  "{n} Regionen ohne Koordinaten werden übersprungen.": "{n} régions sans coordonnées sont ignorées.",
  "{n} Klimareihen fehlt der jüngste abgeschlossene Jahrgang oder sein vollständiger Nachlauf.": "Il manque à {n} séries climatiques le dernier millésime clos ou sa période de suivi complète.",
  "Alles bereits vorhanden — nichts zu laden.": "Tout est déjà là — rien à charger.",
  "Der Server hält Klimareihen vorrätig; Open-Meteo wird nur für Fehlendes gefragt. Eine Region zum ersten Mal kostet dort viel Kontingent — wird es knapp, hält der Lauf an und sagt es.": "Le serveur conserve les séries climatiques ; Open-Meteo n’est sollicité que pour ce qui manque. Le premier chargement d’une région consomme beaucoup de quota — s’il vient à manquer, le chargement s’arrête et le signale.",
  "Nur fehlende auffüllen": "Compléter uniquement les manquants",
  "Erneut versuchen": "Réessayer",
  "Verstanden": "Compris",
  "Lädt …": "Chargement …",
  "Übersicht wird geladen …": "Chargement de l’aperçu …",
  "Neu geladen": "Rechargé",
  "Ohne verfügbare Daten": "Aucune donnée disponible",
  "Foto nicht abrufbar": "Photo indisponible",
  "Standard (Name A–Z)": "Par défaut (nom A–Z)",
  "Die Excel-Datei wurde eingelesen und mit deinem Keller zusammengeführt.": "Le fichier Excel a été lu et fusionné avec votre cave.",
  "Die Wetterdaten werden von Open-Meteo geladen. Bitte das Fenster geöffnet lassen.": "Les données météo proviennent d’Open-Meteo. Gardez cette fenêtre ouverte.",
  "Einzelne Jahrgänge liefern keine Vegetationsdaten (z. B. sehr junge oder zukünftige Jahrgänge) — das ist normal.": "Certains millésimes n’ont pas de données végétatives (très récents ou futurs) — c’est normal.",
  "+ Weitere Rebsorte": "+ Autre cépage",
  "Einen Moment …": "Un instant …",
  "Adresse aktualisieren": "Mettre à jour l’adresse",
  "Adresse speichern": "Enregistrer l’adresse",
  "Link anfordern": "Demander un lien",
  "Passwort setzen": "Définir le mot de passe",
  "Anmelden": "Se connecter",
  "Registrieren": "S’inscrire",
  "Passwort": "Mot de passe",
  "Passwort wiederholen": "Confirmer le mot de passe",
  "Passwort vergessen?": "Mot de passe oublié ?",
  "Einladungscode": "Code d’invitation",
  "Anmeldung wird geprüft …": "Vérification de la connexion …",
  "Kellerbuch wird geöffnet …": "Ouverture du livre de cave …",
  "Hauptnavigation": "Navigation principale",
  "Kontomodus": "Mode du compte",
  "Kellerbuch & Jahrgangsarchiv": "Livre de cave et archives des millésimes",
  "WineLake · Witterung: Open-Meteo Historical Weather API · Karten: OpenStreetMap-Mitwirkende": "WineLake · Météo : Open-Meteo Historical Weather API · Cartes : contributeurs OpenStreetMap",
  "Änderungen im Katalog": "Modifications du catalogue",
  "Katalog-Vorschläge": "Propositions de catalogue",
  "Getrunken": "Consommé",
  "Aus Weinkarten": "Des cartes des vins",
  "Wert": "Valeur",
  "Einkauf": "Achat",
  "Verkauf": "Vente",
  "Gewinn": "Marge",
  "Kennzahl": "Indicateur",
  "Kennzahlen im Vergleich": "Comparaison des indicateurs",
  "Alle Kalenderjahre": "Toutes les années civiles",
  "Alle Weinkarten": "Toutes les cartes",
  "Nach Weinkarte filtern": "Filtrer par carte",
  "Nach Kalenderjahr der Bewegungen filtern": "Filtrer par année des mouvements",
  "Auswertung nach Flaschen oder Wert": "Analyser par bouteilles ou valeur",
  "Ein- & Auslagerungen nach Jahren": "Mouvements par année",
  "Weltkarte des Kellers": "Carte du monde de la cave",
  "Weltkarte wird geladen …": "Chargement de la carte …",
  "Keine Positionen mit Koordinaten für diese Auswahl.": "Aucune entrée géolocalisée pour cette sélection.",
  "Noch keine Daten.": "Pas encore de données.",
  "Differenz": "Différence",
  "Aus dem Bewegungsprotokoll ab Aufzeichnungsbeginn — frühere Ein-/Auslagerungen sind nicht rekonstruierbar. Der Wert basiert auf dem hinterlegten Jahrgangspreis.": "Depuis le journal des mouvements — les mouvements antérieurs ne peuvent être reconstitués. La valeur repose sur le prix du millésime.",
  "Witterungsprofil des Jahrgangs": "Profil météo du millésime",
  "Jahrgang wählen": "Choisir un millésime",
  "Vergleichsjahr": "Année de comparaison",
  "Vergleichsjahr wählen": "Choisir l’année de comparaison",
  "Mit anderem Jahr vergleichen": "Comparer avec une autre année",
  "Lädt alle verfügbaren Jahre des Open-Meteo-Archivs in einem Abruf und berechnet die Mittelwerte.": "Charge toutes les années disponibles de l’archive Open-Meteo en une requête et calcule les moyennes.",
  "Import abgeschlossen": "Importation terminée",
  "Beenden": "Terminer",
  "Weine durchsuchen …": "Rechercher des vins …",
  "Einlagerung neu–alt": "Entrée, du plus récent",
  "Einlagerung alt–neu": "Entrée, du plus ancien",
  "Nach Weintyp": "Par type de vin",
  "Nach Zuckerkategorie": "Par catégorie de sucre",
  "Nach Ländern": "Par pays",
  "Nach Regionen": "Par région",
  "Nach Rebsorten": "Par cépage",
  "Nach Winzern": "Par vigneron",
  "Kellerbestand": "Stock de la cave",
  "Weltkarte · {was}": "Carte du monde · {was}",
  "Nach Weintyp filtern": "Filtrer par type de vin",
  "Nach Jahrgang filtern": "Filtrer par millésime",
  "Nach Winzer filtern": "Filtrer par vigneron",
  "Nach Lagerort filtern": "Filtrer par rangement",
  "Nach Trinkreife filtern": "Filtrer par maturité",
  "Nach Lieblingsweinen filtern": "Filtrer par coups de cœur",
  "Ohne Lagerort": "Sans rangement",
  "Keine Weine gefunden. Lege einen Wein an oder passe Suche und Filter an.": "Aucun vin trouvé. Ajoutez un vin ou ajustez la recherche et les filtres.",
  "Länder": "Pays",
  "Winzer & Weine": "Vignerons et vins",
  "Regionen & Winzer": "Régions et vignerons",
  "ein Winzer": "1 vigneron",
  "{n} Winzer": "{n} vignerons",
  "eine Region": "1 région",
  "{n} Regionen": "{n} régions",
  "eine Flasche": "1 bouteille",
  "{n} Flaschen": "{n} bouteilles",
  "Alle von {n} annehmen": "Tout accepter de {n}",
  "Alle von {n} ablehnen": "Tout refuser de {n}",
  "Ähnliche Einträge im Katalog": "Entrées similaires dans le catalogue",
  "Annehmen und zusammenführen": "Accepter et fusionner",
  "Getrennt lassen": "Garder séparé",
  "Zusammenführen mit …": "Fusionner avec …",
  "Bereits im Katalog": "Déjà au catalogue",
  "In {n} Kellern": "Dans {n} caves",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird — bis dahin wird nichts vorgeschlagen.": "Des entrées similaires existent déjà dans le catalogue. Décidez au cas par cas — d’ici là, rien n’est proposé.",
  "Alle zusammenführen": "Tout fusionner",
  "Alle getrennt lassen": "Tout garder séparé",
  "Offene Entscheidungen": "Décisions en attente",
  "Keine offenen Entscheidungen.": "Aucune décision en attente.",
  "Gilt für die Oberfläche sowie für Zahlen-, Datums- und Währungsangaben.": "S’applique à l’interface ainsi qu’aux formats de nombre, date et monnaie.",

  /* Offline-Nutzung und Synchronisation */
  "Daten synchronisieren": "Synchroniser les données",
  "lokal": "local",
  "Lokale Änderungen · noch nicht übertragen": "Modifications locales · pas encore transmises",
  "Konflikt · bitte abgleichen": "Conflit · veuillez synchroniser",
  "Stände werden verglichen …": "Comparaison des versions …",
  "Beide Stände stimmen überein. Es war nichts zu übertragen.": "Les deux versions concordent. Il n’y avait rien à transmettre.",
  "Die lokalen Änderungen wurden auf den Server übertragen.": "Les modifications locales ont été transmises au serveur.",
  "Der Serverstand war neuer und wurde übernommen.": "La version du serveur était plus récente et a été adoptée.",
  "Der Server ist nicht erreichbar. Die Anwendung arbeitet mit dem lokalen Stand weiter; Änderungen bleiben auf diesem Gerät gesichert und werden beim nächsten erfolgreichen Abgleich übertragen.": "Le serveur est injoignable. L’application continue avec la version locale ; les modifications restent enregistrées sur cet appareil et seront transmises lors de la prochaine synchronisation réussie.",
  "Der Abgleich ist fehlgeschlagen.": "La synchronisation a échoué.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Beide Stände lassen sich nicht zusammenführen, ohne dass Angaben verloren gingen — bitte einen davon auswählen. Der andere wird überschrieben.": "Cet appareil et le serveur ont chacun été modifiés depuis la dernière synchronisation. Les deux versions ne peuvent pas être fusionnées sans perte d’informations — veuillez en choisir une. L’autre sera écrasée.",
  "Dieses Gerät": "Cet appareil",
  "Server": "Serveur",
  "Letzte Bewegung": "Dernier mouvement",
  "Bewegungen": "Mouvements",
  "Serverstand {v}": "Version du serveur {v}",
  "Achtung: Dieses Gerät hat kein gefülltes Kellerbuch. „Dieses Gerät behalten“ würde den Serverstand leeren.": "Attention : cet appareil ne contient pas de livre de cave rempli. « Conserver cet appareil » viderait la version du serveur.",
  "Achtung: Auf dem Server liegt kein gefülltes Kellerbuch. „Server behalten“ würde den hiesigen Stand verwerfen.": "Attention : le serveur ne contient pas de livre de cave rempli. « Conserver le serveur » supprimerait la version de cet appareil.",
  "Später entscheiden": "Décider plus tard",
  "Server behalten": "Conserver le serveur",
  "Dieses Gerät behalten": "Conserver cet appareil",

  /* Titel der Dialoge */
  "Info": "Info",
  "Region bearbeiten": "Modifier la région",
  "Winzer bearbeiten": "Modifier le vigneron",
  "Wein bearbeiten": "Modifier le vin",
  "Jahrgang bearbeiten": "Modifier le millésime",
  "Kritik bearbeiten": "Modifier la note",
  "Entnahme": "Sortie",
  "Zugang bearbeiten": "Modifier l’entrée",
  "Entnahme bearbeiten": "Modifier la sortie",

  /* Etiketten offline */
  "wartet auf Übertragung": "en attente d’envoi",
  "Ein wartendes Etikett wurde übertragen.": "Une étiquette en attente a été envoyée.",
  "{n} wartende Etiketten wurden übertragen.": "{n} étiquettes en attente ont été envoyées.",
  "Ein Etikett wird im Hintergrund für den Offline-Betrieb geladen.": "Une étiquette est téléchargée en arrière-plan pour le mode hors ligne.",
  "{n} Etiketten werden im Hintergrund für den Offline-Betrieb geladen.": "{n} étiquettes sont téléchargées en arrière-plan pour le mode hors ligne.",
  "Ein Foto wartet auf Übertragung": "Une photo en attente d’envoi",
  "{n} Fotos warten auf Übertragung": "{n} photos en attente d’envoi",
  "Wirklich löschen?": "Supprimer définitivement ?",
  "Bewertet": "Noté",
  "Noch nichts erfasst. Sobald du Flaschen einlagerst, entnimmst oder eine Kritik schreibst, entsteht hier der Verlauf.": "Rien d’enregistré pour l’instant. Dès que vous rangez ou sortez des bouteilles, ou écrivez une critique, l’historique se construit ici.",
  "Datum der Entnahme": "date de la sortie",
  "Datum der zugehörigen Entnahme — die Kritik selbst ist undatiert": "Date de la sortie correspondante — la critique elle-même n’est pas datée",

  /* Kritik erfassen und zuordnen */
  "Nicht zugeordnet": "Non attribué",
  "noch nicht zugeordnet": "pas encore attribué",
  "Wein zuordnen": "Attribuer un vin",
  "Ohne Angabe": "Sans précision",
  "Kritik zuordnen": "Attribuer la critique",
  "— Wein wählen —": "— Choisir un vin —",
  "＋ Neuen Wein anlegen": "＋ Créer un nouveau vin",
  "Noch nicht zuordnen": "Attribuer plus tard",
  "Wein suchen oder wählen …": "Rechercher ou choisir un vin …",
  "Wein (Notiz)": "Vin (note)",
  "Name des Weins": "Nom du vin",
  "＋ Neuen Winzer anlegen": "＋ Créer un nouveau vigneron",
  "Name des Winzers": "Nom du vigneron",
  "＋ Neuer Jahrgang": "＋ Nouveau millésime",
  "Jahr (leer = N.V.)": "Année (vide = N.V.)",
  "Zuordnen": "Attribuer",
  "Etikett fotografieren": "Photographier l’étiquette",
  "Anderes Bild": "Autre image",
  "Wird übertragen …": "Envoi en cours …",
  "Diese Kritik wartet noch auf ihren Wein. Wähle den passenden aus oder lege ihn neu an.": "Cette critique attend encore son vin. Choisissez le bon ou créez-le.",
  "Erst der Eindruck, dann die Zuordnung: Wenn der Wein noch nicht feststeht, genügen ein Name und ein Foto des Etiketts.": "L’impression d’abord, le classement ensuite : si le vin n’est pas encore identifié, un nom et une photo de l’étiquette suffisent.",
  "Bitte wenigstens einen Namen oder Hinweis zum Wein angeben — sonst lässt sich die Kritik später nicht wiedererkennen.": "Indiquez au moins un nom ou un indice sur le vin, sinon la critique ne sera pas reconnaissable plus tard.",
  "Bitte einen Namen für den Wein angeben.": "Veuillez indiquer un nom pour le vin.",
  "Bitte einen Namen für den Winzer angeben.": "Veuillez indiquer un nom pour le vigneron.",
  "Bitte eine Region für den neuen Winzer wählen.": "Veuillez choisir une région pour le nouveau vigneron.",
  "Bitte einen Wein wählen.": "Veuillez choisir un vin.",
  "Bitte ein gültiges Jahr angeben oder das Feld für N.V. leer lassen.": "Indiquez une année valide ou laissez le champ vide pour N.V.",
  "Bitte den Kritiker bzw. die Quelle angeben.": "Veuillez indiquer le critique ou la source.",
  "Der Wert muss zwischen {min} und {max} liegen ({label}).": "La valeur doit être comprise entre {min} et {max} ({label}).",
  "Dieser Jahrgang hat bereits ein Etikett — durch das neue ersetzen": "Ce millésime a déjà une étiquette — la remplacer par la nouvelle",
  "z. B. „Riesling, grünes Etikett, Mosel\"": "p. ex. « Riesling, étiquette verte, Moselle »",
  "Kein Treffer für „{q}“": "Aucun résultat pour « {q} »",
  "Ohne Zuordnung anlegen": "Enregistrer sans vin",

  /* Zusammenführen: Feldvergleich */
  "Merkmal": "Attribut",
  "gleich": "identique",
  "wird ergänzt": "sera ajouté",
  "abweichend": "diffère",
  "ohne weitere Angaben": "sans autre précision",
  "Rohdaten anzeigen": "Afficher les données brutes",
  "Rohdaten ausblenden": "Masquer les données brutes",
  "Keine widersprüchlichen Angaben — beim Zusammenführen bleibt alles erhalten und beide Seiten ergänzen sich.": "Aucune donnée contradictoire — la fusion conserve tout et les deux côtés se complètent.",
  "Eine Angabe widerspricht sich. Sie wird vom Ziel übernommen, die der Quelle geht verloren.": "Une donnée est contradictoire. Celle de la cible est conservée, celle de la source est perdue.",
  "{n} Angaben widersprechen sich. Sie werden vom Ziel übernommen, die der Quelle gehen verloren.": "{n} données sont contradictoires. Celles de la cible sont conservées, celles de la source sont perdues.",
  "Eine abweichende Angabe der Quelle geht dabei verloren.": "Une donnée divergente de la source sera perdue.",
  "{n} abweichende Angaben der Quelle gehen dabei verloren.": "{n} données divergentes de la source seront perdues.",
  "Eigenes Label": "Étiquette personnelle",
  "Trinkfenster ab": "Fenêtre de dégustation à partir de",
  "Breite": "Latitude",
  "Länge": "Longitude",
  "＋ Neue Region anlegen": "＋ Créer une nouvelle région",
  "Bitte einen Namen für die neue Region angeben.": "Veuillez indiquer un nom pour la nouvelle région.",
  "Bitte gültige Koordinaten für die neue Region angeben (Dezimalgrad).": "Veuillez indiquer des coordonnées valides pour la nouvelle région (degrés décimaux).",
  "Trinkreife ab · früh zuerst": "Fenêtre de dégustation début · au plus tôt",
  "Trinkreife ab · spät zuerst": "Fenêtre de dégustation début · au plus tard",
  "Trinkreife bis · früh zuerst": "Fenêtre de dégustation fin · au plus tôt",
  "Trinkreife bis · spät zuerst": "Fenêtre de dégustation fin · au plus tard",

  /* Altbestand freigeben */
  "Lokal geführt": "Géré localement",
  "Für den Katalog freigeben": "Libérer pour le catalogue",
  "{n} Region": "{n} région",
  "Wirklich {n} Eintrag freigeben?": "Libérer vraiment {n} entrée ?",
  "Wirklich {n} Einträge freigeben?": "Libérer vraiment {n} entrées ?",
  "waren beim Einführen des Katalogs bereits vorhanden. Solche Angaben werden absichtlich nicht vorgeschlagen — sonst hätte der erste Abgleich das halbe Kellerbuch auf einmal vorgelegt. Willst du sie gemeinsam pflegen, gib sie hier frei.": "étaient déjà présents lors de l’introduction du catalogue. Ces données ne sont volontairement jamais proposées, sinon la première synchronisation aurait soumis la moitié du livre de cave d’un coup. Si vous voulez les tenir en commun, libérez-les ici.",
  "Winzer und Region eines Weins gehen dabei mit; ohne sie wäre der Eintrag im Katalog unbrauchbar. Liegt derselbe Wein dort schon unter anderer Kennung, entsteht ein zweiter Eintrag — dafür gibt es das Zusammenführen.": "Un vin emmène son vigneron et sa région ; sans eux, l’entrée du catalogue serait inutilisable. Si le même vin s’y trouve déjà sous un autre identifiant, une seconde entrée apparaît — c’est à cela que sert la fusion.",
  "Ein weiterer Eintrag wurde einmal abgelehnt und bleibt dauerhaft lokal.": "Une autre entrée a été refusée une fois et reste locale définitivement.",
  "{n} weitere Einträge wurden einmal abgelehnt und bleiben dauerhaft lokal.": "{n} autres entrées ont été refusées une fois et restent locales définitivement.",
  "Speichern fehlgeschlagen": "Échec de l’enregistrement",

  /* Nachgetragen (Prüfung tests/i18n.test.mjs) */
  "Label": "Étiquette",
  "Wein auf der Karte suchen …": "Rechercher un vin sur la carte …",
  "Kein Wein auf der Karte passt zur Suche.": "Aucun vin de la carte ne correspond à la recherche.",
  "Gliederung": "Structure",
  "Land → Region → Winzer → Weine": "Pays → Région → Vigneron → Vins",
  "Label → Land → Region → Winzer → Weine": "Étiquette → Pays → Région → Vigneron → Vins",
  "Inhaltsverzeichnis (Länder & Regionen)": "Table des matières (pays et régions)",
  "Seitenzahlen": "Numéros de page",
  "PDF herunterladen": "Télécharger le PDF",
  "Suchen (Wein, Winzer, Region) …": "Rechercher (vin, vigneron, région) …",
  "{n} von {m} angezeigt — weiter scrollen für mehr": "{n} sur {m} affichés — continuez à faire défiler",
  "Im Katalog verfügbar": "Disponible dans le catalogue",
  "Aus dem Katalog übernommen:": "Repris du catalogue :",
  "Verknüpfung mit dem Katalog": "lien avec le catalogue",
  "pH": "pH",

  /* Kritik-Einstellungen */
  "Standard-Bewertungsschema": "Échelle de notation par défaut",
  "Meine Kritiken im gemeinsamen Katalog zeigen": "Afficher mes critiques dans le catalogue commun",
  "Bewertung, Kritiker, Anlass, Speisenbegleitung und Verkostungsnotiz sind für alle Konten sichtbar, zusammen mit deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "La note, le critique, l’occasion, l’accord mets-vins et la note de dégustation sont visibles par tous les comptes, avec votre nom d’utilisateur. Les stocks, emplacements et prix ne le sont jamais.",
  "Deine Kritiken bleiben in deinem Kellerbuch und erscheinen bei keinem anderen Konto.": "Vos critiques restent dans votre livre de cave et n’apparaissent dans aucun autre compte.",
  "Gespeichert.": "Enregistré.",
  "Das hat nicht geklappt.": "Cela n’a pas fonctionné.",
  "Eigene Kritik": "Critique personnelle",
  "Mein Keller": "Ma cave",
  "Suchbereich": "Périmètre de recherche",
  "geteilt": "partag\u00e9e",
  "Suche löschen": "Effacer la recherche",
  "Umfang der Listen": "Portée des listes",
  "Anzeigen": "Afficher",
  "Keller mit Bestand": "Cave avec stock",
  "Gesamter Keller": "Cave entière",
  "Nur eigene Kritiken zeigen": "N’afficher que mes critiques",
  "Alle Kritiken einblenden (eine weitere)": "Afficher toutes les critiques (une de plus)",
  "Alle Kritiken einblenden ({n} weitere)": "Afficher toutes les critiques ({n} de plus)",
  "Du hast diesen Wein noch nicht bewertet.": "Vous n’avez pas encore noté ce vin.",
  "Im gemeinsamen Katalog zeigen": "Afficher dans le catalogue commun",
  "Bewertung, Kritiker, Anlass, Pairing und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "La note, le critique, l’occasion, l’accord et la remarque sont visibles par tous les comptes — avec votre nom d’utilisateur. Les stocks, emplacements et prix jamais.",
  "Deine Kritiken bleiben in deinem Kellerbuch.": "Vos critiques restent dans votre livre de cave.",
  "Bewertung, Kritiker, Speisenbegleitung und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Der Anlass bleibt privat, ebenso Bestände, Lagerorte und Preise.": "La note, le critique, l’accord mets-vins et la remarque sont visibles par tous les comptes — avec votre nom d’utilisateur. L’occasion reste privée, tout comme les stocks, emplacements et prix.",

  /* Jahrgänge mit ähnlicher Witterung */
  "Jahrgänge mit ähnlicher Witterung in {region}": "Millésimes à la météo similaire en {region}",
  "sehr ähnlich": "très similaire",
  "gut vergleichbar": "bien comparable",
  "in Teilen ähnlich": "partiellement similaire",
  "gering ähnlich": "peu similaire",
  "nahezu deckungsgleich": "quasi identique",
  "wärmer": "plus chaud",
  "später reif": "plus tard à maturité",
  "früher reif": "plus tôt à maturité",
  "Tage": "jours",
  "kühler": "plus frais",
  "nasser": "plus humide",
  "trockener": "plus sec",
  "sonniger": "plus ensoleillé",
  "trüber": "plus couvert",
  "Bodenwasser Periodenende": "Eau du sol en fin de période",

  /* Witterung: Abruf und Kennzahlen im Vergleich */
  "Witterung abrufen": "Récupérer la météo",
  "Neu abrufen": "Récupérer à nouveau",
  "Abrufen": "Récupérer",
  "Klimareihe laden": "Charger la série climatique",
  "Klimareihe aktualisieren": "Actualiser la série climatique",
  "Klimareihe wird geladen …": "Chargement de la série climatique …",
  "Ø letzte 10 Jahre": "Ø 10 dernières années",
  "Ø alle Jahre": "Ø toutes les années",
  "Ø Temperatur": "Ø température",
  "Ø Höchsttemperatur": "Ø température maximale",
  "Ø Tiefsttemperatur": "Ø température minimale",
  "Sonnenstunden": "Heures d’ensoleillement",
  "Gradtage (Basis 10 °C)": "Degrés-jours (base 10 °C)",
  "Hitzetage ≥ 30 °C": "Jours de chaleur ≥ 30 °C",
  "Jahrgang {jahr} ist abgeschlossen, fehlt aber noch in der geladenen Klimareihe — „Klimareihe aktualisieren“ nimmt ihn in Vergleich und Stilprofil auf.": "Le millésime {jahr} est clos mais manque encore dans la série climatique chargée — « Actualiser la série climatique » l’ajoute à la comparaison et au profil de style.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife liegen jetzt im Archiv. „Klimareihe aktualisieren“ ersetzt die Schätzung.": "Pluie de maturation encore extrapolée — les jours suivant la maturité sont désormais dans l’archive. « Actualiser la série climatique » remplace l’estimation.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife fehlen im Archiv. Ab {datum} „Klimareihe aktualisieren“.": "Pluie de maturation encore extrapolée — les jours suivant la maturité manquent encore dans l’archive. À partir du {datum}, utilisez « Actualiser la série climatique ».",
  "Diese Klimareihe stammt aus einer älteren Fassung — einmal „Klimareihe aktualisieren“, damit Vergleich und Stilprofil neu gerechnet werden.": "Cette série climatique provient d’une version antérieure — utilisez une fois « Actualiser la série climatique » pour recalculer la comparaison et le profil de style.",

  /* Stilprofil */
  "Stilprofil {jahr}": "Profil de style {jahr}",
  "Reife geschätzt: {datum}": "Maturité estimée : {datum}",
  "im Mittel der Region: {datum}": "moyenne de la région : {datum}",
  "Wärme": "Chaleur",
  "Nächte in der Reife": "Nuits pendant la maturation",
  "Regen in der Reife": "Pluie pendant la maturation",
  "Bodenwasser am Ende": "Eau du sol en fin de période",
  "Bodenwasser zur Reife": "Eau du sol à maturité",
  "sehr kühl": "très frais",
  "kühl": "frais",
  "typisch": "typique",
  "warm": "chaud",
  "sehr warm": "très chaud",
  "mild": "douces",
  "sehr mild": "très douces",
  "sehr trocken": "très sec",
  "trocken": "sec",
  "feucht": "humide",
  "sehr nass": "très pluvieux",
  "ausgetrocknet": "épuisée",
  "knapp": "faible",
  "reichlich": "abondante",
  "sehr reichlich": "très abondante",
  "Hitzejahr: opulent und alkoholreich, die Säure wird knapp": "Année caniculaire : opulent et alcooleux, l’acidité se fait rare",
  "Reife mit Frische: warme Tage, kühle Nächte — volle Reife bei erhaltener Säure": "Maturité et fraîcheur : journées chaudes, nuits fraîches — pleine maturité, acidité préservée",
  "Kühl und nass: schlank, säurebetont, stark von der Selektion abhängig": "Frais et humide : svelte, acidulé, très dépendant de la sélection",
  "Volle Reife, mehr Körper und Alkohol, weichere Säure": "Pleine maturité, plus de corps et d’alcool, acidité plus souple",
  "Schlank und säurebetont, eher niedriger Alkohol": "Svelte et acidulé, alcool plutôt faible",
  "Kühle Nächte bewahren Frische, Aromatik und Farbe": "Les nuits fraîches préservent fraîcheur, arômes et couleur",
  "Milde Nächte: weichere Frucht, Aromatik eher reif als frisch": "Nuits douces : fruit plus tendre, arômes plus mûrs que frais",
  "Regen zur Reife: Verdünnungs- und Fäulnisgefahr": "Pluie à la maturation : risque de dilution et de pourriture",
  "Trockene Reife: gesundes Lesegut": "Maturation sèche : raisins sains",
  "Trockenstress: kleine Beeren, dicke Schalen, Konzentration und Tannin": "Stress hydrique : petites baies, peaux épaisses, concentration et tanins",
  "Gute Wasserversorgung: größere Beeren, zugänglicher Stil": "Bonne alimentation en eau : baies plus grosses, style plus accessible",
  "Ein für die Region typischer Jahrgang ohne ausgeprägte Richtung": "Un millésime typique de la région sans orientation marquée",
  /* Katalogabgleich: Vorschläge, Änderungen, Sync-Bericht */
  "(ohne Namen)": "(sans nom)",
  "Ablehnen (+{n} abhängige)": "Refuser (+{n} dépendants)",
  "Angenommene Vorschläge gehen in den Katalog und stehen allen Cloud-Konten zur Verfügung. Übernommen wird nur, was der Vorschlag ändert; fehlende Winzer und Regionen gehen mit, wenn sie selbst vorgeschlagen sind. Eine abgelehnte Aufnahme bleibt beim Vorschlagenden dauerhaft lokal, eine abgelehnte Änderung nur in dieser Fassung.": "Les propositions acceptées entrent au catalogue et sont disponibles pour tous les comptes cloud. Seul ce que la proposition modifie est appliqué ; les vignerons et régions manquants suivent s’ils ont eux-mêmes été proposés. Un ajout refusé reste définitivement local chez son auteur, une modification refusée seulement dans cette version.",
  "Dein Eintrag wird auf die Katalogfassung zurückgesetzt. Bestände, Lagerorte und Preise bleiben.": "Ton entrée est ramenée à la version du catalogue. Stocks, emplacements et prix sont conservés.",
  "Deine Fassung bleibt bei dir stehen; der Eintrag bleibt mit dem Katalog verbunden und bekommt weitere Änderungen mit.": "Ta version reste chez toi ; l’entrée reste liée au catalogue et reçoit les modifications suivantes.",
  "Deine Fassung → Katalogfassung": "Ta version → version du catalogue",
  "Der Eintrag steht nicht mehr im Katalog — vermutlich wurde er zusammengeführt. Annehmen ist nicht möglich.": "L’entrée ne figure plus au catalogue — elle a sans doute été fusionnée. Impossible de l’accepter.",
  "Der Eintrag wird danach nur bei dir geführt. Unter „Lokal geführt“ kannst du ihn später wieder freigeben.": "L’entrée sera ensuite gérée uniquement chez toi. Tu pourras la libérer de nouveau plus tard sous « Géré localement ».",
  "Der Katalog war nicht erreichbar; das holt der nächste Abgleich nach.": "Le catalogue était injoignable ; la prochaine synchronisation rattrapera cela.",
  "Der Katalog wurde seit dem Vorschlag geändert, aber an anderen Stellen. Angenommen wird nur, was dieser Vorschlag ändert.": "Le catalogue a changé depuis la proposition, mais ailleurs. Seul ce que modifie cette proposition sera accepté.",
  "Der Katalog wurde seit dem Vorschlag geändert. Markierte Felder hat auch jemand anderes geändert — beim Annehmen gilt dieser Vorschlag.": "Le catalogue a changé depuis la proposition. Quelqu’un d’autre a aussi modifié les champs marqués — en acceptant, cette proposition l’emporte.",
  "Diese Einträge verweisen auf einen Winzer oder eine Region, die nur bei dir geführt werden. Im Katalog wären sie unbrauchbar — gib den Bezug unten unter „Lokal geführt“ frei, dann gehen sie beim nächsten Abgleich mit.": "Ces entrées renvoient à un vigneron ou à une région gérés uniquement chez toi. Au catalogue, elles seraient inutilisables — libère la référence ci-dessous sous « Géré localement » et elles suivront à la prochaine synchronisation.",
  "Ein Eintrag im Katalog zusammengeführt.": "Une entrée du catalogue fusionnée.",
  "{n} Einträge im Katalog zusammengeführt.": "{n} entrées du catalogue fusionnées.",
  "Ein Vorschlag wurde abgelehnt.": "Une proposition a été refusée.",
  "{n} Vorschläge wurden abgelehnt.": "{n} propositions ont été refusées.",
  "Ein Vorschlag wurde angenommen.": "Une proposition a été acceptée.",
  "{n} Vorschläge wurden angenommen.": "{n} propositions ont été acceptées.",
  "Ein neuer Vorschlag ging an den Verwalter.": "Une nouvelle proposition a été transmise à l’administrateur.",
  "{n} neue Vorschläge gingen an den Verwalter.": "{n} nouvelles propositions ont été transmises à l’administrateur.",
  "Eine Katalogänderung weicht von deiner Fassung ab — siehe Katalog → Änderungen.": "Une modification du catalogue diffère de ta version — voir Catalogue → Modifications.",
  "{n} Katalogänderungen weichen von deiner Fassung ab — siehe Katalog → Änderungen.": "{n} modifications du catalogue diffèrent de ta version — voir Catalogue → Modifications.",
  "Eine Katalogänderung übernommen.": "Une modification du catalogue appliquée.",
  "{n} Katalogänderungen übernommen.": "{n} modifications du catalogue appliquées.",
  "Hängt an einem abgelehnten Winzer oder einer abgelehnten Region.": "Dépend d’un vigneron ou d’une région refusés.",
  "Im Katalog wurden zwei Einträge vereint — deine Bestände und Verweise sind mitgewandert.": "Deux entrées du catalogue ont été réunies — tes stocks et références ont suivi.",
  "In Prüfung": "En cours d’examen",
  "in Prüfung": "en cours d’examen",
  "Jahrgang entfernt": "millésime retiré",
  "neuer Jahrgang": "nouveau millésime",
  "Katalog befüllt": "catalogue rempli",
  "Katalog wird abgeglichen …": "Synchronisation du catalogue …",
  "Katalog: nichts Neues.": "Catalogue : rien de nouveau.",
  "Katalogfassung wiederherstellen": "Rétablir la version du catalogue",
  "Keine inhaltliche Änderung erkennbar.": "Aucune modification de contenu décelable.",
  "Korrektur verwerfen": "Abandonner la correction",
  "Korrigieren": "Corriger",
  "Mit Korrektur annehmen": "Accepter avec correction",
  "Laden fehlgeschlagen.": "Échec du chargement.",
  "Legst du im Cloud-Modus einen Wein, Winzer oder eine Region an oder änderst etwas daran, wird das dem Verwalter des Katalogs vorgelegt. Bis zur Entscheidung arbeitest du ungehindert mit deiner eigenen Fassung weiter.": "Si, en mode cloud, tu crées ou modifies un vin, un vigneron ou une région, cela est soumis à l’administrateur du catalogue. En attendant la décision, tu continues librement avec ta propre version.",
  "Meine behalten": "Garder la mienne",
  "Nichts zu entscheiden.": "Rien à décider.",
  "Wirklich zurückziehen?": "Vraiment retirer ?",
  "Zu entscheiden": "À décider",
  "Zuletzt eingespielt": "Appliqué récemment",
  "Zurückgehalten": "Retenus",
  "Zurückziehen": "Retirer",
  "auch im Katalog geändert": "aussi modifié au catalogue",
  "davon {n} als Bezug mitgenommen": "dont {n} entraînées comme références",
  "davon {n} als Folge": "dont {n} par voie de conséquence",
  "durch {n}": "par {n}",
  "von {n}": "de {n}",
  "entfernt": "retiré",
  "geändert": "modifié",
  "neu aufgenommen": "ajouté",
  "neu": "nouveau",
  "unbekannt": "inconnu",
  "veraltet": "obsolète",
  "vorhanden": "présent",
  "werden nur bei dir geführt — weil sie beim Einführen des Katalogs schon vorhanden waren oder weil du einen Vorschlag zurückgezogen hast. Solche Angaben werden nicht vorgeschlagen. Willst du sie gemeinsam pflegen, gib sie hier frei.": "sont gérés uniquement chez toi — parce qu’ils existaient déjà à l’introduction du catalogue ou parce que tu as retiré une proposition. Ces données ne sont pas proposées. Si tu veux les entretenir en commun, libère-les ici.",
  "zusammengeführt": "fusionné",
  "{n} abgelehnt": "{n} refusées",
  "{n} angenommen": "{n} acceptées",
  "{typ} „{name}“ fehlt im Katalog und wartet nicht als Vorschlag — so nicht annehmbar.": "{typ} « {name} » manque au catalogue et n’attend pas en tant que proposition — impossible d’accepter ainsi.",
  "{typ} „{name}“ wartet selbst auf Prüfung und wird beim Annehmen mitgenommen.": "{typ} « {name} » attend lui-même un examen et sera repris lors de l’acceptation.",
  "Änderungen am gemeinsamen Katalog, die deine Weine, Winzer oder Regionen betreffen. Wo deine Fassung noch dem alten Stand entsprach, wurde still nachgezogen. Bestände, Lagerorte und Preise bleiben immer unberührt.": "Modifications du catalogue commun qui concernent tes vins, vignerons ou régions. Là où ta version correspondait encore à l’ancien état, elle a été mise à jour discrètement. Stocks, emplacements et prix restent toujours intacts.",
  "Beschreibung": "Description",
  "angenommen": "accepté",
  "abgelehnt": "refusé",
  "Aufnahme": "Ajout",
  "Änderung": "Modification",
  "übernommen": "appliqué",
  "lokal geführt": "géré localement",
  "bereits aktuell": "déjà à jour",
  /* Katalogabgleich: Aufnahme mit eigener Fassung */
  "deine Fassung bleibt": "ta version reste",
  "Du hast seit deinem Vorschlag weiter daran gearbeitet. Deine neuere Fassung bleibt und geht als Änderung an den Verwalter.": "Tu as continué à y travailler après ta proposition. Ta version plus récente reste et part comme modification à l’administrateur.",
  /* Katalogabgleich: Dreiwegevergleich */
  "Hier hat der Katalog ein Feld geändert, das du selbst anders geändert hast. Alles Übrige ist bereits übernommen. „Meine behalten“ lässt deine Angabe stehen; sie geht dann als Änderungsvorschlag an den Verwalter.": "Ici, le catalogue a modifié un champ que tu as toi-même modifié autrement. Tout le reste est déjà appliqué. « Garder la mienne » laisse ta saisie en place ; elle part alors comme proposition de modification à l’administrateur.",
  /* Kellerbuch-Abgleich: Zusammenführen */
  "Auf beiden Seiten gab es Änderungen. Sie widersprachen sich nicht und wurden zusammengeführt.": "Il y avait des modifications des deux côtés. Elles ne se contredisaient pas et ont été fusionnées.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Alles, was sich nicht widerspricht, wird zusammengeführt. An diesen Stellen haben beide Seiten dasselbe verschieden geändert:": "Depuis la dernière synchronisation, quelque chose a été modifié sur cet appareil et sur le serveur. Tout ce qui ne se contredit pas est fusionné. À ces endroits, les deux côtés ont modifié la même chose différemment :",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Ohne gemeinsamen Ausgangsstand lassen sich beide nicht sicher zusammenführen — bitte einen davon auswählen. Der andere wird überschrieben.": "Depuis la dernière synchronisation, quelque chose a été modifié sur cet appareil et sur le serveur. Sans état de départ commun, ils ne peuvent pas être fusionnés en toute sécurité — choisis-en un. L’autre sera écrasé.",
  "Bestand {g}": "Stock {g}",
  "Ein Stand wird ganz übernommen, der andere überschrieben — auch dort, wo sich nichts widerspricht.": "Un état est repris entièrement, l’autre écrasé — même là où rien ne se contredit.",
  "Ein Widerspruch · Serverstand {v}": "Une contradiction · version du serveur {v}",
  "{n} Widersprüche · Serverstand {v}": "{n} contradictions · version du serveur {v}",
  "Stattdessen einen Stand ganz übernehmen": "Reprendre plutôt un état entier",
  "Von diesem Gerät: {a} · vom Server: {b}": "De cet appareil : {a} · du serveur : {b}",
  "Zusammenführen, Server gilt": "Fusionner, le serveur l’emporte",
  "Zusammenführen, dieses Gerät gilt": "Fusionner, cet appareil l’emporte",
  "gelöscht": "supprimé",
  "ja": "oui",
  "nein": "non",
  "nur auf dem Server": "seulement sur le serveur",
  "nur hier": "seulement ici",
  "verschieden": "différent",
  "… und {n} weitere": "… et {n} autres",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt der Server.": "Les deux états ont été fusionnés ; pour l’unique contradiction, le serveur l’emporte.",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt dieses Gerät.": "Les deux états ont été fusionnés ; pour l’unique contradiction, cet appareil l’emporte.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt der Server.": "Les deux états ont été fusionnés ; pour {n} contradictions, le serveur l’emporte.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt dieses Gerät.": "Les deux états ont été fusionnés ; pour {n} contradictions, cet appareil l’emporte.",
  "Bewegung": "Mouvement",
  "Einstellung": "Réglage",
  "Katalogabweichung": "Écart au catalogue",
  "Favorit": "Favori",
  "Trinkreife ab": "À boire à partir de",
  "Trinkreife bis": "À boire jusqu’à",
  "Dieses Gerät hat lange nicht abgeglichen — ein Teil des Katalogprotokolls liegt nicht mehr vor. Was von der Katalogfassung abweicht, steht zur Entscheidung unter Katalog → Änderungen, statt als Vorschlag gesendet zu werden.": "Cet appareil n’a pas été synchronisé depuis longtemps — une partie du journal du catalogue n’est plus disponible. Ce qui diffère de la version du catalogue est soumis à votre décision sous Catalogue → Modifications, au lieu d’être envoyé comme proposition.",
  "Eine eigene Änderung ging direkt in den Katalog.": "Une de vos modifications est entrée directement dans le catalogue.",
  "{n} eigene Änderungen gingen direkt in den Katalog.": "{n} de vos modifications sont entrées directement dans le catalogue.",
  "Lokale Kopie konnte nicht gespeichert werden": "La copie locale n’a pas pu être enregistrée",
  "Alle von {n} annehmen (ohne {k} mit Dublettenverdacht)": "Tout accepter de {n} (sauf {k} doublons présumés)",
  "Ein Vorschlag mit Dublettenverdacht bleibt zur Einzelprüfung offen.": "Une proposition soupçonnée d’être un doublon reste ouverte pour un examen individuel.",
  "{n} Vorschläge mit Dublettenverdacht bleiben zur Einzelprüfung offen.": "{n} propositions soupçonnées d’être des doublons restent ouvertes pour un examen individuel.",
  "Mit Korrektur trotzdem neu aufnehmen": "Ajouter comme nouveau malgré tout, avec correction",
  "Mit „{name}“ zusammenführen": "Fusionner avec « {name} »",
  "Trotzdem neu aufnehmen": "Ajouter comme nouveau malgré tout",
  "möglich": "possible",
  "wahrscheinlich Dublette": "doublon probable",
  "wahrscheinlich dieselbe": "probablement le même",
  "Alle wahrscheinlichen zusammenführen ({n})": "Fusionner tous les probables ({n})",
  "mögliche Dublette": "doublon possible",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird. Eine wahrscheinliche Dublette wird bis dahin nicht vorgeschlagen, eine mögliche schon.": "Des entrées similaires existent déjà dans le catalogue. Décidez pour chacune s’il faut fusionner ou garder séparé. Un doublon probable n’est pas proposé d’ici là ; un doublon possible l’est.",
  "Name gleich": "même nom",
  "Name ähnlich": "nom similaire",
  "Lage nur bei einem": "lieu-dit d’un seul côté",
  "Land gleich": "même pays",
  "Region gleich": "même région",
  "andere Region": "autre région",
  "Ort gleich": "même village",
  "gleicher Winzer": "même producteur",
  "Winzer nur bei einem": "producteur d’un seul côté",
  "Typ gleich": "même type",
  "+ {n} weitere": "+ {n} de plus",
  "Alle {n} zeigen": "Afficher les {n}",
  "Weitere {n} zeigen": "Afficher {n} de plus",
  "weniger": "moins",
  "{n} von {gesamt}": "{n} sur {gesamt}",
  /* Mehrfachauswahl in Filtern */
  "Suchen …": "Rechercher …",
  "Keine Treffer": "Aucun résultat",
  /* Rundum-Etikett (3D) */
  "Rundum aufnehmen (3D)": "Capture panoramique (3D)",
  "Rundum-Etikett": "Étiquette panoramique",
  "Ziehen dreht die Flasche · zwei Finger, Mausrad oder Doppeltippen vergrößern": "Faites glisser pour tourner la bouteille · zoomez à deux doigts, avec la molette ou d’un double appui",
  "Kein Zugriff auf die Kamera. Bitte den Zugriff in den Einstellungen des Browsers erlauben.": "Pas d’accès à la caméra. Veuillez l’autoriser dans les réglages du navigateur.",
  "Es wurde keine Kamera gefunden.": "Aucune caméra n’a été trouvée.",
  "Die Kamera konnte nicht gestartet werden.": "La caméra n’a pas pu être démarrée.",
  "Die Kamera ist in diesem Browser nicht verfügbar.": "La caméra n’est pas disponible dans ce navigateur.",
  "Die Aufnahme ist fehlgeschlagen.": "La capture a échoué.",
  "Der Upload ist fehlgeschlagen.": "L’envoi a échoué.",
  "Etwas langsamer drehen": "Tournez un peu plus lentement",
  "Flasche weiterdrehen": "Continuez à tourner la bouteille",
  "Es wurde keine volle Umdrehung erkannt. Bitte die Flasche ganz herumdrehen, bis der Balken voll ist, und dabei im Umriss halten.": "Aucun tour complet n’a été détecté. Tournez la bouteille d’un tour entier jusqu’à ce que la barre soit pleine, en la gardant dans le contour.",
  "Flasche in den Umriss stellen. Telefon ruhig halten, am besten aufgestützt.": "Placez la bouteille dans le contour. Tenez le téléphone immobile, idéalement calé.",
  "Flasche erkannt. Start tippen und die Flasche langsam einmal ganz herumdrehen — umgreifen ist erlaubt.": "Bouteille détectée. Touchez Démarrer et tournez lentement la bouteille d’un tour entier — vous pouvez reprendre votre prise.",
  "Wird berechnet …": "Calcul en cours …",
  "Langsam drehen, bis der Balken voll ist": "Tournez lentement jusqu’à ce que la barre soit pleine",
  "Flasche nicht erkannt — bitte im Umriss halten": "Bouteille non détectée — gardez-la dans le contour",
  "Der Umriss der Flasche war nicht sicher zu erkennen. Hals und Kapsel folgen der gewählten Form und können verzerrt sein.": "Le contour de la bouteille n’a pas pu être détecté avec certitude. Le col et la capsule suivent la forme choisie et peuvent être déformés.",
  "Fertig": "Terminé",
  "Rundum-Etikett prüfen": "Vérifier l’étiquette panoramique",
  "Vorschau des Rundum-Etiketts": "Aperçu de l’étiquette panoramique",
  "Kapsellänge": "Longueur de la capsule",
  "Die Kapselkante war nicht eindeutig zu erkennen. Bitte mit dem Regler an die Linie anpassen.": "Le bord de la capsule n’a pas pu être détecté clairement. Ajustez la ligne avec le curseur.",
  "Einzelne Stellen wurden ergänzt. Langsameres Drehen ergibt ein schärferes Bild.": "Certaines zones ont été complétées. Tourner plus lentement donne une image plus nette.",
  "Wiederholen": "Recommencer",
  "Rundum-Etikett aufnehmen": "Capturer l’étiquette panoramique",
  "Flaschenform": "Forme de bouteille",
  "Start": "Démarrer",
  "Neu beginnen": "Recommencer depuis le début",
  "Zum Drehen ziehen": "Faites glisser pour tourner",
  "Folie": "Métal",
  "Wachs": "Cire",
  "Schraubverschluss": "Capsule à vis",
  "Ohne Kapsel": "Sans capsule",
  "Bitte mindestens drei Fotos wählen, besser sechs rundum.": "Choisissez au moins trois photos, idéalement six tout autour.",
  "Auf Foto {n} wurde keine Flasche erkannt. Die ganze Flasche sollte aufrecht im Bild stehen.": "Aucune bouteille n’a été détectée sur la photo {n}. La bouteille entière doit être debout dans le cadre.",
  "Foto {n} passt zu keinem anderen Foto. Zwischen zwei Fotos die Flasche nur um etwa ein Sechstel weiterdrehen.": "La photo {n} ne correspond à aucune autre. Entre deux photos, ne tournez la bouteille que d’environ un sixième.",
  "Die Fotos zeigen die Flasche nicht von allen Seiten. Bitte rundum fotografieren, etwa alle 60°.": "Les photos ne montrent pas la bouteille sous tous les angles. Photographiez-la tout autour, environ tous les 60°.",
  "Die Berechnung ist fehlgeschlagen.": "Le calcul a échoué.",
  "Einzelne Stellen sind nur von der Seite zu sehen und unscharf. Mehr Fotos rundum helfen.": "Certaines zones ne sont visibles que de côté et sont floues. Davantage de photos tout autour aident.",
  "Fotos aufnehmen oder auswählen — am besten sechs rundum.": "Prenez ou choisissez des photos — idéalement six tout autour.",
  "Ein Foto. Mindestens drei, besser sechs.": "Une photo. Au moins trois, idéalement six.",
  "{n} Fotos. Mindestens drei, besser sechs.": "{n} photos. Au moins trois, idéalement six.",
  "{n} Fotos. Berechnen tippen.": "{n} photos. Touchez Calculer.",
  "Flasche auf eine Fläche stellen. Gleichmäßiges Licht, kein Blitz.": "Posez la bouteille sur une surface. Lumière uniforme, sans flash.",
  "Telefon etwa auf Höhe der Flaschenmitte, die ganze Flasche im Bild.": "Tenez le téléphone à hauteur du milieu de la bouteille, la bouteille entière dans le cadre.",
  "Nach jedem Foto die Flasche um etwa 60° weiterdrehen, immer in dieselbe Richtung, am Bauch angefasst (eine lose Kapsel dreht sonst mit) — sechs Fotos rundum.": "Après chaque photo, tournez la bouteille d’environ 60°, toujours dans le même sens, en la tenant par le corps (sinon une capsule lâche tourne avec) — six photos tout autour.",
  "Foto {n}": "Photo {n}",
  "Foto {n} entfernen": "Retirer la photo {n}",
  "Foto 1 ist die Vorderseite: mit dem Vorderetikett in der Mitte beginnen. Die Fotos lassen sich durch Ziehen umsortieren.": "La photo 1 est l’avant : commencez avec l’étiquette avant au centre. Faites glisser les photos pour changer l’ordre.",
  "Foto {n}, Vorderseite": "Photo {n}, avant",
  "Zum Verschieben ziehen oder Pfeiltasten.": "Faites glisser ou utilisez les flèches pour déplacer.",
  "Foto jetzt an Stelle {n}.": "Photo maintenant en position {n}.",
  "vorne": "avant",
  "Foto aufnehmen": "Prendre une photo",
  "Fotos auswählen": "Choisir des photos",
  "Aufnahmeart": "Mode de prise de vue",
  "Video": "Vidéo",
  "Fotos": "Photos",
  "Berechnen": "Calculer",
  "Etikettfoto zeigen": "Afficher la photo de l’étiquette",
  "3D-Ansicht zeigen": "Afficher la vue 3D",
  "Die Flasche hat die Form {form}. Die Form wurde angepasst.": "La bouteille a la forme {form}. La forme a été adaptée.",
};

export { texte };
